import React from 'react';
import DatasourceSettings from '../../settings_sidebar/datasource/DatasourceSettings.jsx';
import MapWidgetContentSettings from './MapWidgetContentSettings.jsx';

function MapWidgetSettings({widgetId}) {
  return (
    <DatasourceSettings
      widgetId={widgetId}
      ChartSettingsComponent={MapWidgetContentSettings}
    />
  )
}

export default MapWidgetSettings;